var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 310.09 203.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-219.95 -430.6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.8449 0 0 2.9076 -1304.9 -535.77)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f10002",
    d: "M585 332.36H596V402.36H585z",
    color: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f10002",
    d: "M536 361.36H645V373.36H536z",
    color: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61 -105)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#092c70",
    d: "M487 437.36l35 25v-25h-35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#092c70",
    d: "M475 443.36v21h31l-31-21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f10002",
    d: "M475 437.36v3l36 24h5l-41-27"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 1120 -105)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#092c70",
    d: "M487 437.36l35 25v-25h-35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#092c70",
    d: "M475 443.36v21h31l-31-21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f10002",
    d: "M475 437.36v3l36 24h5l-41-27"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 560 419.86)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#092c70",
    d: "M487 437.36l35 25v-25h-35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#092c70",
    d: "M475 443.36v21h31l-31-21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f10002",
    d: "M475 437.36v3l36 24h5l-41-27"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 1058 -62)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#092c70",
    d: "M487 437.36l35 25v-25h-35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#092c70",
    d: "M475 443.36v21h31l-31-21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f10002",
    d: "M475 437.36v3l36 24h5l-41-27"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.93ebf407.svg";
export { ForwardRef as ReactComponent };